import styled from "styled-components";
import { Button as MuiButton } from "@material-ui/core";

export const ToolbarCancelMuiButton = styled(MuiButton)`
  && {
    color: #1976d2;
    text-transform: none;
    font-size: 14px;
    font-weight: 500;
    &:hover {
      background-color: transparent;
    }
  }
`;

/** type="button" — não submete o form; o envio real ocorre após confirmação no modal. */
export const ToolbarSendMuiButton = styled(MuiButton).attrs({
  variant: "contained",
  type: "button",
})`
  && {
    box-shadow: none;
    text-transform: none;
    font-size: 14px;
    font-weight: 500;
    padding: 8px 36px;
  }
  &&[data-send-valid="true"]:not(:disabled) {
    background-color: #1976d2;
    color: #fff;
    &:hover {
      background-color: #1565c0;
    }
  }
  &&[data-send-valid="false"],
  &&:disabled {
    background-color: #e0e0e0 !important;
    color: #9e9e9e !important;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 0 24px 120px 24px;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: -16px -24px 2px -40px;
  padding: 24px;
  background-color: #fafafa;
  border-radius: 0;
  box-sizing: border-box;
  border-bottom: 1px solid #e0e0e0;
`;

export const Title = styled.h1`
  font-size: 24px;
  font-weight: 600;
  color: #000;
  margin: 0;
  line-height: 1.2;
`;

export const Subtitle = styled.p`
  font-size: 14px;
  color: #666;
  margin: 0;
  line-height: 1.4;
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-right: 24px;
`;

export const InfoBanner = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background-color: #e5f7fd;
  border-radius: 4px;
  margin-top: 8px;
  
  .info-icon {
    color: #1976D2;
    font-size: 20px;
    flex-shrink: 0;
  }
  
  .info-text {
    font-size: 14px;
    color: #014361;
    line-height: 1.4;
    
    a {
      color: #1976D2;
      text-decoration: underline;
      font-weight: 700;
      &:hover {
        text-decoration: none;
      }
    }
  }
`;

export const StyledFileInput = styled.div`
  .RaFileInput-dropZone {
    border: 2px dashed ${props => props.isValid ? "#4CAF50" : "#BDBDBD"};
    border-radius: 8px;
    padding: 16px 20px !important;
    text-align: center;
    background-color: ${props => props.isValid ? "#F1F8F4" : "#FAFAFA"};
    cursor: pointer;
    transition: all 0.3s ease;
    
    &:hover {
      border-color: ${props => props.isValid ? "#4CAF50" : "#1976D2"};
      background-color: ${props => props.isValid ? "#E8F5E9" : "#F5F5F5"};
    }
    
    .MuiSvgIcon-root {
      color: ${props => props.isValid ? "#4CAF50" : "#1976D2"};
      font-size: 36px !important;
      margin-bottom: 8px !important;
    }
    
    p {
      font-size: 14px;
      color: #666;
      margin: 8px 0;
      
      &:first-of-type {
        font-weight: 500;
        color: #333;
      }
      
      &:last-of-type {
        font-size: 12px;
        color: #999;
      }
    }
  }
  
  .RaFileInput-removeButton {
    margin-top: 12px;
  }
`;

export const SuccessFileDisplay = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;

export const FileName = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #000;
  margin-bottom: 8px;
  text-align: center;
`;

export const FileFormat = styled.div`
  font-size: 12px;
  color: #666;
  margin-top: 4px;
  text-align: center;
`;

export const ValidationStatus = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 16px;
  background-color: #FFF3E0;
  border-radius: 4px;
  color: #E65100;
  font-size: 14px;
`;

export const SuccessBanner = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background-color: #E8F5E9;
  border-radius: 4px;
  border: 1px solid #4CAF50;
  
  .success-icon {
    color: #4CAF50;
    font-size: 20px;
    font-weight: bold;
    flex-shrink: 0;
  }
  
  .success-text {
    font-size: 14px;
    color: #2E7D32;
    font-weight: 500;
  }
`;

export const ErrorBanner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px 16px;
  background-color: #FFEBEE;
  border-radius: 4px;
  border: 1px solid #F44336;
  
  .error-header {
    display: flex;
    align-items: center;
    gap: 12px;
  }
  
  .error-icon {
    color: #F44336;
    font-size: 20px;
    flex-shrink: 0;
  }
  
  .error-text {
    font-size: 14px;
    color: #C62828;
    font-weight: 500;
  }
`;

/* Card principal (#fafafa) com info do arquivo + linha + div vermelha com margem (estilo da imagem) */
export const FileFeedbackCard = styled.div`
  background-color: #f5f5f5;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
  overflow: hidden;
  margin-top: 16px;
`;

export const FileInfoRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  padding: 16px 20px;
`;

export const FileInfoName = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #333;
`;

export const FileInfoMeta = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  font-size: 13px;
  color: #666;
`;

export const FileInfoDownloadIcon = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  margin: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  border-radius: 4px;
  
  &:hover {
    background-color: rgba(0, 0, 0, 0.04);
  }
`;

/* Linha abaixo do nome do arquivo / informações do arquivo */
export const FileFeedbackSeparator = styled.div`
  height: 1px;
  background-color: #e0e0e0;
  margin: 0;
`;

export const FileErrorSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
  margin: 16px 20px 20px 20px;
  padding: 16px 20px;
  background-color: #FDEDED;
  border-radius: 8px;
  
  .file-error-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    min-width: 40px;
    border-radius: 50%;
    color: #D74141;
  }
  
  .file-error-message {
    flex: 1;
    font-size: 14px;
    color: #5F2120;
    line-height: 1.5;
    min-width: 200px;
    
    strong {
      font-weight: 700;
    }
  }
  
  .file-error-button {
    white-space: nowrap;
  }
`;

